import React from "react";
export const CampusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.23717 5.71151L5.75 5.54057V5V2.86476L11.25 3.65047V11.25H2.75V6.54057L5.23717 5.71151Z"
      stroke="#778086"
      strokeWidth="1.5"
    />
    <rect x="5" y="7.75" width="1.5" height="1.5" fill="#778086" />
    <rect x="7.75" y="7.75" width="1.5" height="1.5" fill="#778086" />
    <rect x="7.75" y="5" width="1.5" height="1.5" fill="#778086" />
  </svg>
);
